import { Typography } from '@mui/material';
import { DecisionTreeResultSummaryFieldsFragment, useGetDecisionTreeRunResultQuery } from '../../../../../../../../../../../../../generated/core-api/graphql-react-query';
import StyledBox from './styles';

interface RunSequenceItemProps {
  step: DecisionTreeResultSummaryFieldsFragment
}
export default function RunSequenceItem(props: RunSequenceItemProps) {
  const { step } = props;
  const resultData = useGetDecisionTreeRunResultQuery({ input: { id: step.id ?? '' } });
  const stepResult = resultData.data?.getDecisionTreeRun;
  return (
    <StyledBox>
      <Typography variant="subtitle2">{stepResult?.decisionTree.name}</Typography>
      <Typography variant="body2">{stepResult?.summary}</Typography>
    </StyledBox>
  );
}
